import axios from "../axios";

const updateConfigures = async function (accessToken,data) {
    try {
        const response = await axios.post('configure/updateConfigures', data ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        console.log(e);
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateConfigures;
